(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', './Header/SiteLinks/SubMenuDrawer', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('./Header/SiteLinks/SubMenuDrawer'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.SubMenuDrawer, global.propTypes);
    global.Link = mod.exports;
  }
})(this, function (exports, _react, _SubMenuDrawer, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _SubMenuDrawer2 = _interopRequireDefault(_SubMenuDrawer);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Link = function (_React$Component) {
    _inherits(Link, _React$Component);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _this.state = {
        originalStyle: _this.props.style,
        style: _this.props.style,
        subGroupLinks: {},
        id: ''
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'handleEnter',
      value: function handleEnter() {
        var style = Object.assign({}, this.state.style, this.props.hoverStyles);

        this.setState({
          style: style,
          hover: true
        });
      }
    }, {
      key: 'handleLeave',
      value: function handleLeave() {
        this.setState({
          style: this.state.originalStyle,
          hover: false
        });
      }
    }, {
      key: 'mobileLinkClick',
      value: function mobileLinkClick(e) {
        var parentNode = e.target.parentNode.id;
        var parentNodeId = document.getElementById(parentNode);
        var grandmaNode = parentNodeId.parentNode;

        if (e.target.id === 'link-selector' && grandmaNode.classList.contains('sub-menu')) {
          e.preventDefault();
        }

        parentNode = parentNode.toLowerCase().replace(/,/g, '');

        this.setState({
          id: parentNode
        });

        this.props.handleLinkGroups(parentNode);
      }
    }, {
      key: 'render',
      value: function render() {
        var rel = this.props.rel || null;
        var list = this.props.list ? this.props.list : null;
        var isOpen = false;
        var subObject = {};

        if (this.props.subLinks) {
          subObject = Object.assign({}, this.props.subLinks[this.state.id]);

          isOpen = this.props.subLinks[this.state.id] ? subObject.subOpen : false;
        }

        var aTag = void 0;
        // Render the href if we have one.
        if (this.props.href) {
          aTag = _react2.default.createElement(
            'a',
            {
              className: this.props.className,
              target: this.props.target,
              href: encodeURI(this.props.href),
              alt: this.props.alt,
              rel: rel,
              style: this.state.style,
              id: this.props.isSubGroupLink ? 'link-selector' : null
            },
            this.props.children,
            ' '
          );
        } else {
          aTag = _react2.default.createElement(
            'a',
            {
              className: this.props.className,
              target: this.props.target,
              alt: this.props.alt,
              rel: rel,
              style: this.state.style,
              id: this.props.isSubGroupLink ? 'link-selector' : null
            },
            this.props.children,
            ' '
          );
        }

        return _react2.default.createElement(
          'div',
          {
            style: this.props.isSubGroupLink ? { display: 'block' } : { display: 'inline-block', 'paddingLeft': '12px' },
            onMouseEnter: this.handleEnter.bind(this),
            onMouseLeave: this.handleLeave.bind(this),
            id: '' + this.props.children,
            onClick: this.props.isMobile ? this.mobileLinkClick.bind(this) : null
          },
          aTag,
          _react2.default.createElement(_SubMenuDrawer2.default, {
            isHovered: this.state.hover,
            list: list,
            isMobile: this.props.isMobile,
            linkClicked: this.state.isClicked,
            isOpen: isOpen,
            height: this.props.height,
            subMenuHeight: this.props.subMenuHeight
          })
        );
      }
    }]);

    return Link;
  }(_react2.default.Component);

  exports.default = Link;


  Link.defaultProps = {
    alt: ''
  };

  Link.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    href: _propTypes2.default.string,
    alt: _propTypes2.default.string,
    target: _propTypes2.default.string,
    hoverStyles: _propTypes2.default.object,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    subLinks: _propTypes2.default.object,
    list: _propTypes2.default.array,
    isSubGroupLink: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    subMenuHeight: _propTypes2.default.object,
    handleLinkGroups: _propTypes2.default.func,
    rel: _propTypes2.default.string,
    height: _propTypes2.default.number
  };
});